module.exports = __webpack_public_path__ + "src/assets/img/ic07.d748aaeb.svg";